import { Flex } from '@mantine/core';
import { useCallback } from 'react';
import { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import DrawerFlowScreenLayout from 'src/UI/drawer-flow/DrawerFlowScreenLayout';
import SelectableItemList from 'src/UI/drawer-flow/SelectableItemList';
import { MeetingNoteData, MeetingNoteTemplateType } from '../MeetingNoteFlow';

const TEMPLATE_TYPE_OPTIONS = [
  {
    id: 'template' as MeetingNoteTemplateType,
    title: 'Use a template',
    description: 'Generate meeting notes using a predefined template',
  },
  {
    id: 'agenda' as MeetingNoteTemplateType,
    title: 'Use an agenda',
    description: 'Generate meeting notes using an uploaded agenda file as the structure',
  },
];

export default function SelectTemplateTypeStep(props: StepProps<MeetingNoteData>) {
  const { data, setData } = props;

  const setSelectedTemplateType = useCallback(
    (templateType: MeetingNoteTemplateType | undefined) => {
      setData({
        ...data,
        templateType,
        selectedTemplateId: undefined,
        selectedAgendaFileId: undefined,
      });
    },
    [data, setData],
  );

  const handleSelectionChange = (selectedIds: string[]) => {
    setSelectedTemplateType((selectedIds[0] as MeetingNoteTemplateType) || undefined);
  };

  return (
    <DrawerFlowScreenLayout
      {...props}
      title="How would you like to structure the meeting note?"
      description="Choose whether to use a template or an agenda file"
      canGoForward={props.canGoForward && !!data.templateType}
    >
      <Flex direction="column" gap="xs" mih={0}>
        <SelectableItemList
          items={TEMPLATE_TYPE_OPTIONS}
          selectedItemIds={data.templateType ? [data.templateType] : []}
          setSelectedItemIds={handleSelectionChange}
          selectMultiple={false}
        />
      </Flex>
    </DrawerFlowScreenLayout>
  );
}
